import { z } from 'zod';

export enum WritingPathStyle {
  Default = 'default',
}

// Base schemas
export const WritingPathSchema = z.object({
  path: z.string(),
  dropsBelowLine: z.boolean(),
});

export type WritingPath = z.infer<typeof WritingPathSchema>;

export type KeyedWritingPath = WritingPath & {
  letter: string;
};
